function ALL_DRUGSTORES(state) {
    return state.drugstores;
};

export {
    ALL_DRUGSTORES,
};